<template>
  <b-card no-body class="cards card-box">
    <div class="p-2">
      <b-button variant="primary" @click="abrirCadastrar">{{ $t("GERAL.NOVO") }}</b-button>
    </div>

    <b-tabela @doisClicksLinha="abrirEditar" :colunas="campos" :dados="items">
      <template v-slot:cell(acoes)="item">
        <div class="d-flex">
            <b-button variant="flat-primary" @click="abrirEditar(item.item.item)">
              <i class="fas fa-edit"></i>
            </b-button>
            <b-button variant="flat-danger" @click="excluir(item.item.item)">
              <i class="fas fa-trash"></i>
            </b-button>
          </div>
      </template>
    </b-tabela>
  </b-card>
</template>

<script>
import PermissoesService from "@/common/services/permissoes/permissoes.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Confirmacao from "@/components/confirmacao/Confirmacao";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import Swal from "sweetalert2";

export default {
  name: "Perfis",
  data() {
    return {
      campos: [
        {
          key: "nome",
          label: this.$t("GERAL.PERFIL"),
        },
        {
          key: "acoes",
          label: this.$t("GERAL.ACOES"),
          tdClass: "acoes",
        },
      ],
      items: [],
      totalRows: 5,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: this.$t("GERAL.PAGINACAO") }],
    };
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: this.$t("MENU.PERFIS") }]);
    this.listar();
  },
  methods: {
    listar() {
      this.$store.dispatch(START_LOADING);
      PermissoesService.listar()
        .then((result) => {
          result.data.data.itens.sort((a, b) => a.nome.localeCompare(b.nome));
          this.items = result.data.data.itens;
          this.totalRows = result.data.data.paginacao.totalDeElementos / this.perPage;
        })
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err.response.data.errors,
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    abrirCadastrar() {
      this.$router.push({ name: "perfis-formulario" });
    },
    abrirEditar(item) {
      this.$router.push({ name: "perfis-formulario", params: { id : item.id } });
    },
    excluir(item) {
      Confirmacao.SimNao(
        this,
        null,
        this.$t("GERAL.CONFIRMAR_EXCLUIR_PERFIL").formatUnicorn({
          nome: item.nome,
        })
      ).then(async (result) => {
        if (result.value) {
          this.$store.dispatch(START_LOADING);
          PermissoesService.excluir(item.id)
            .then(() => {
              Swal.fire({
                title: this.$t("GERAL.SUCCESSO"),
                text: this.$t("USUARIOS.MENSAGEM_EXCLUIDO"),
                icon: "success",
                confirmButtonText: this.$t("GERAL.OK"),
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$router.go();
                }
              });
            })
            .catch((err) => {
              Swal.fire({
                title: this.$t("GERAL.ERRO"),
                text: err.response.data.errors,
                icon: "error",
              });
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },
  },
};
</script>
